import { LightningCssLoader } from './loader'

export { LightningCssMinifyPlugin } from './minify'
export default LightningCssLoader
